import { useCallback } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { FileSecurity } from 'router/subrouters/DataRoom/models/DataRoom';
import { isBasicSelected } from 'router/subrouters/DataRoom/utils';

export const WATERMARK_FIELD_NAMES = [
  'watermarkFullName',
  'watermarkEmail',
  'watermarkIpAddress',
  'watermarkDiagonal',
  'watermarkHeader',
  'watermarkFooter',
];

const DEFAULT_CHECKED_WATERMARK_FIELDS = [
  'watermarkFullName',
  'watermarkEmail',
  'watermarkIpAddress',
  'watermarkDiagonal',
];

export default function useSelectLevel() {
  const { change } = useForm();
  const { values, initialValues } = useFormState();

  const { fileSecurity } = values || {};

  const selectLevel = useCallback(
    (level: FileSecurity) => {
      if (level === fileSecurity) return;

      if (level === initialValues?.fileSecurity) {
        change('expirationDays', initialValues?.expirationDays);
        change(
          'blurProtection.checked',
          initialValues?.blurProtection?.checked,
        );
        change(
          'blurProtection.isMixed',
          initialValues?.blurProtection?.isMixed,
        );

        WATERMARK_FIELD_NAMES.forEach((name) => {
          change(`${name}.checked`, initialValues?.[name]?.checked);
          change(`${name}.isMixed`, initialValues?.[name]?.isMixed);
        });
      } else {
        change('expirationDays', undefined);
        change('blurProtection.checked', false);
        change('blurProtection.isMixed', false);

        WATERMARK_FIELD_NAMES.forEach((name) => {
          const checked =
            !isBasicSelected(level) &&
            DEFAULT_CHECKED_WATERMARK_FIELDS.includes(name);

          change(`${name}.checked`, checked);
          change(`${name}.isMixed`, false);
        });
      }

      change('fileSecurity', level);
    },
    [change, initialValues, fileSecurity],
  );

  return selectLevel;
}
